import { IContact } from '~/shared';
import { ContactsStages } from '../../models/Contacts';
import { createSlice } from '../wrappers';

interface IContactsState {
	activeContactsState: ContactsStages;
	selectedContact: IContact | null;
}

const initialState: IContactsState = {
	activeContactsState: ContactsStages.ALL_CONTACTS,
	selectedContact: null,
};

const contactsSlice = createSlice({
	name: 'contacts',
	initialState,
	reducers: {
		setActiveContactsState: (state, action) => {
			state.activeContactsState = action.payload;
			if (action.payload === ContactsStages.ALL_CONTACTS) {
				state.selectedContact = null;
			}
		},
		setSelectedContact: (state, action) => {
			state.selectedContact = action.payload;
		},
	},
});

export const { setActiveContactsState, setSelectedContact } =
	contactsSlice.actions;

export default contactsSlice.reducer;
